import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PreferencesCustomDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // selectedNode: '',
      dropdownVisible: false,
      nodes: [],
    };
  }

  toggleDropdown = () => {
    this.setState(prevState => ({
      dropdownVisible: !prevState.dropdownVisible,
    }), () => {
      if (this.state.dropdownVisible) {
        document.addEventListener('click', this.hideDropdown, false);
      } else {
        document.removeEventListener('click', this.hideDropdown, false);
      }
    });
  }

  hideDropdown = e => {
    if (this.studySelElement && this.studySelElement.contains(e.target)) {
      return;
    }
    this.toggleDropdown();
    
  }

  updatePreferences = node => {
    const { dbKey } = this.props.field;
    this.toggleDropdown();
    this.props.updatePreferences(
      dbKey,
      node
    );
  }

  render() {
    return (
      <div className="preference-custom-dropdown" style={{ width: '100%' }} 
        ref={node => {this.studySelElement = node;
        return this.studySelElement}}>
        <span className="custom-dropdown-label">{this.props.label}</span>
        <div className="custom-dropdown-div" style={{ width: this.props.style && this.props.style.width }}>
          <button
            type = "button"
            className={`custom-dropdown-btn ${this.state.dropdownVisible ? 'active' : ''}`}
            onClick={this.toggleDropdown}
          >
            {this.props.field.defaultValue ? this.props.field.defaultValue :
              this.props.field.values[0]}
            <span className="arrow-icon" />
          </button>
          {this.state.dropdownVisible &&
            <div className="custom-dropdown-list">
              {this.props.field.values !== undefined &&
                <div className="custom-result-listing">
                  <ul>
                    {(this.props.field.values.length > 0 ?
                    this.props.field.values : this.state.nodes).map(node => (
                      <li key={node} className="custom-result-list">
                        <span title={node} onClick={() => this.updatePreferences(node)} 
                          className="custom-result-list-title">{node}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              }
            </div>
          }
        </div>
      </div>
    );
  }
}

PreferencesCustomDropdown.propTypes = {
  field: PropTypes.shape({
    values: PropTypes.arrayOf(PropTypes.string),
    defaultValue: PropTypes.number,
    dbKey: PropTypes.string,
  }),
  style: PropTypes.shape({
    width: PropTypes.string,
  }),
  label: PropTypes.string,
  updatePreferences: PropTypes.func,
};

export default PreferencesCustomDropdown;
